import {
  CREATE_REGION_START,
  CREATE_REGION_SUCCESS,
  CREATE_REGION_FAILED,
  REMOVE_REGION_START,
  REMOVE_REGION_SUCCESS,
  REMOVE_REGION_FAIL,
  FETCH_REGIONS_START,
  FETCH_REGIONS_SUCCESS,
  FETCH_REGIONS_FAILED,
  CLEAR_REGION_ERROR,
  UPDATE_REGION_START,
  UPDATE_REGION_SUCCESS,
  UPDATE_REGION_FAIL,
  DELETE_REGION_START,
  DELETE_REGION_SUCCESS,
  DELETE_REGION_FAIL,
  UPDATE_BROKER_SUCCESS,
  UPDATE_AREA_SUCCESS,
  REMOVE_AREA_START,
  REMOVE_AREA_FAIL,
  REMOVE_AREA_SUCCESS,

  FETCH_BROKER_REGIONS_START,
  FETCH_BROKER_REGIONS_SUCCESS,
  FETCH_BROKER_REGIONS_FAILED


} from "../store/types";




function getBrokerRegionsFromAreas(userAreas, regions) {
  const brokerRegions = [];

  for (const region of regions) {
    let areas = region.areas ? Object.values(region.areas) : [];
    for (const area of areas) {
      if (userAreas.includes(area)) {
        brokerRegions.push(region);
        break;
      }
    }
  }

  return brokerRegions;
}

export const fetchBrokerRegions = () => (dispatch) => (firebase) => {
  const { RegionsRef, auth } = firebase;

  dispatch({ type: FETCH_BROKER_REGIONS_START });

  const userAreas = Object.keys(auth?.currentUser?.profile?.Areas || {});
  const brokerRegions = [];

  RegionsRef.on("value", (snapshot) => {
    try {
      const regions = snapshot.val() ? Object.values(snapshot.val()) : [];

      if (userAreas.length > 0 && regions.length > 0) {
        brokerRegions.push(...getBrokerRegionsFromAreas(userAreas, regions));
      } else {
        dispatch({
          type: FETCH_BROKER_REGIONS_FAILED,
          payload: "No matching broker regions found",
        });
      }
      dispatch({
        type: FETCH_BROKER_REGIONS_SUCCESS,
        payload: brokerRegions,
      });
    } catch (error) {
      console.error("Error fetching regions:", error);
      dispatch({
        type: FETCH_BROKER_REGIONS_FAILED,
        payload: error.message,
      });
    }
  });
};




//fetch regions
export const fetchAllRegions = () => (dispatch) => (firebase) => {
  const { RegionsRef } = firebase;

  dispatch({ type: FETCH_REGIONS_START });

  RegionsRef.on("value", (snapshot) => {
    try {
      const regions = snapshot.val() ? Object.values(snapshot.val()) : [];
      dispatch({
        type: FETCH_REGIONS_SUCCESS,
        payload: regions,
      });
    } catch (error) {
      console.error("Error fetching regions:", error);
      dispatch({
        type: FETCH_REGIONS_FAILED,
        payload: error.message,
      });
    }
  });
};

// Add a new region
export const addRegion = (regionData) => (dispatch) => async (firebase) => {
  const { RegionRef, AreaRef, singleUserAreasRef, SingleAreaRef, singleUserRef, SingleRegionRef, singleUserRegionRef, SingleAreaRegionsRef } = firebase;

  let regionId = "";

  try {
    dispatch({
      type: CREATE_REGION_START,
      payload: null,
    });
    if (regionData) {

      let regionName = regionData.regionName;
      let selectedBrokers = regionData.shareBrokers;
      let areaList = regionData.areas;

      if (selectedBrokers.length > 0) {
        selectedBrokers = Object.fromEntries(
          Object.entries(regionData.shareBrokers).map(([key, value]) => [value, value])
        );
        console.log(`selectedBrokres after normalisation: ${JSON.stringify(selectedBrokers)}`)
        regionData.shareBrokers = selectedBrokers;
      }

      if (areaList.length > 0) {
        areaList = Object.fromEntries(
          Object.entries(regionData.areas).map(([key, value]) => [value, value])
        );
        console.log(`areas after normalisation: ${JSON.stringify(areaList)}`)
        regionData.areas = areaList;
      }

      if (regionName === "") {
        dispatch({
          type: CREATE_REGION_FAILED,
          payload: "Error: Region name not provided",
        });
        return { success: false, message: "Error: Region name not provided" };
      }
    }

    try {
      const snapshot = await RegionRef.push(regionData);
      console.log(`SNAPSHOT: ${snapshot}`);
      regionId = snapshot.key;
      console.log('Region pushed successfully. Key:', snapshot.key);

      await SingleRegionRef(regionId).child("regionId").set(regionId);

      const singleRegionSnapshot = await SingleRegionRef(regionId).once("value"); //retrieving created region

      if (regionData.areas) {
        let regionIdName = {    //contains the regionId as the key and regionName as the value
          [regionId]: regionData.regionName,
        };
        console.log("Region to be added to area:", regionIdName, typeof regionIdName);
        for (const areaId of Object.keys(regionData.areas)) {
          const areaObj = regionData.areas[areaId];
          console.log(`areaObj:`, areaObj);
          console.log(`areaId: ${areaId}`);

          console.log(`Adding area: ${areaId}`);
          console.log(`RegionId: ${regionId}, Region name: ${regionData.regionName}`);
          await SingleAreaRegionsRef(areaId).update(regionIdName);
        }
      }

      if (regionData.shareBrokers) {
        console.log(`in shareBrokers condition: ${JSON.stringify(regionData.shareBrokers)}`);
        const brokerKeys = Object.keys(regionData.shareBrokers);

        for (let index = 0; index < brokerKeys.length; index++) {
          console.log(`In loop`)
          const element = brokerKeys[index];

          try {
            console.log(`Broker id to add region into: ${element}`)
            await singleUserRegionRef(element).child(regionId).set(regionData.regionName);
            console.log('Region pushed to the user successfully.');

            try {
              let userSnapshot = await singleUserRef(element).once("value");
              if (userSnapshot) {
                dispatch({
                  type: UPDATE_BROKER_SUCCESS,
                  payload: userSnapshot.val(),
                });
              }
            } catch (error) {
              console.log(`Error while getting userSnapshot in addArea`)
            }

          } catch (error) {
            console.error('Error pushing Region to the user:', error);
          }
        }
      }

      dispatch({
        type: CREATE_REGION_SUCCESS,
        payload: singleRegionSnapshot.val(),
      });

    } catch (error) {
      console.error('Error pushing Region:', error);
    }
    return { success: true, message: "Region was created!" };

  } catch (error) {
    console.error("Error adding region:", error);

    dispatch({
      type: CREATE_REGION_FAILED,
      payload: error.message,
    });
    return { success: false, message: error.message };
  }
};

//update region
export const updateRegion = (regionData) => (dispatch) => async (firebase) => {
  const { SingleRegionRef, SingleAreaRef, singleUserRegionRef, singleUserAreasRef, singleUserRef } = firebase;

  console.log(`In updateRegion action`);

  const updateData = {
    regionName: regionData.regionName,
    regionId: regionData.regionId,
    areas: regionData.areas,
    selectedBranchName: regionData.selectedBranchName,
    shareBrokers: regionData?.shareBrokers ? regionData?.shareBrokers : null,
  }

  const regionId = regionData.regionId;

  try {
    dispatch({
      type: UPDATE_REGION_START,
      payload: null,
    });
    if (regionData) {

      if (regionId === "" || regionData === null) {
        dispatch({
          type: UPDATE_REGION_FAIL,
          payload: "Error: Update is missing regionId",
        });
        return { success: false, message: "Error: Update is missing an regionId" };
      }
    }

    try {
      await SingleRegionRef(regionId).update(updateData);
      const snapshot = await SingleRegionRef(regionId).once('value');
      console.log(`Region updated successfully. ${updateData}`);

      try {
        let matchedBrokersKeys = Object.keys(regionData.shareBrokers);

        for (let index = 0; index < matchedBrokersKeys.length; index++) {
          const element = matchedBrokersKeys[index];

          await singleUserRegionRef(element).child(regionId).set(regionData.regionName);

          let userSnapshot = await singleUserRef(element).once("value");

          if (userSnapshot) {
            try {
              dispatch({
                type: UPDATE_BROKER_SUCCESS,
                payload: userSnapshot.val(),
              });
            } catch (error) {
              console.log(`Could not dispatch update broker success message`)
            }
          }
        }
      } catch (error) {
        console.log(`Error while updating the linked brokers region details: ${error}`)
      }

      console.log(`Region snapshot: ${JSON.stringify(snapshot.val())}`)
      dispatch({
        type: UPDATE_REGION_SUCCESS,
        payload: snapshot.val(),
      });

    } catch (error) {
      console.error('Error updating Region:', error);
    }

    return { success: true, message: "Broker added!" };

  } catch (error) {
    console.error("Error adding broker to region:", error);

    dispatch({
      type: UPDATE_REGION_FAIL,
      payload: error.message,
    });
    return { success: false, message: error.message };
  }
};

//update region areas
export const updateRegionAreas = (regionData) => (dispatch) => async (firebase) => {
  const { UpdateRegionRef, UpdateAreaRef, singleUserAreasRef, SingleRegionRef, singleUserRef, SingleAreaRegionsRef, SingleAreaRef } = firebase;

  const regionId = regionData.regionId;
  const areas = regionData.areas;
  //const shareBrokers = areaData.shareBrokers;

  try {
    dispatch({
      type: UPDATE_REGION_START,
      payload: null,
    });
    if (regionData) {

      if (regionId === "") {
        dispatch({
          type: UPDATE_REGION_FAIL,
          payload: "Error: Update is missing a regionId",
        });
        return { success: false, message: "Error: Update is missing a regionId" };
      }
    }

    try {

      let regionIdName = {    //contains the regionId as the key and regionName as the value
        [regionId]: regionData.regionName,
      };

      for (let index = 0; index < areas.length; index++) {
        let element = {
          [areas[index]]: areas[index],
        };

        console.log("Element to update:", element, typeof element);
        await UpdateRegionRef(regionId).update(element);
        const snapshot = await SingleRegionRef(regionId).once('value');
        console.log('area pushed successfully.');

        try {
          console.log("Element to update 2:", regionIdName, typeof regionIdName);
          await SingleAreaRegionsRef(areas[index]).update(regionIdName);
          const areaSnapshot = await SingleAreaRef(areas[index]).once('value');
          console.log('Area pushed to the user successfully.');

          dispatch({
            type: UPDATE_AREA_SUCCESS,
            payload: areaSnapshot.val(),
          });
        } catch (error) {
          console.error('Error pushing region to the area:', error);
        }

        dispatch({
          type: UPDATE_REGION_SUCCESS,
          payload: snapshot.val(),
        });
      }

    } catch (error) {
      console.error('Error pushing Area:', error);
    }

    return { success: true, message: "Area added!" };

  } catch (error) {
    console.error("Error adding area to region:", error);

    dispatch({
      type: UPDATE_REGION_FAIL,
      payload: error.message,
    });
    return { success: false, message: error.message };
  }
};

//remove area from region
export const removeAreaFromRegion = (area, regionData) => (dispatch) => async (firebase) => {
  const { UpdateRegionRef, SingleRegionRef, UpdateAreaRef, singleUserAreasRef, SingleAreaRef, usersRef, singleUserRef, RegionRef, UpdateAreaRegionRef } = firebase;

  const regionId = regionData.regionId;
  const areaId = area.areaId;

  try {
    dispatch({
      type: REMOVE_AREA_START,
      payload: null,
    });
    if (regionData) {

      if (regionId === "") {
        dispatch({
          type: REMOVE_REGION_FAIL,
          payload: "Error: No region ID provided",
        });
        return { success: false, message: "Error: No region ID provided" };
      }
    }

    let matchedEntry = {}

    //removing region from area
    try {
      console.log("Removing region from area:", area);

      SingleRegionRef(regionId).on("value", (snapshot) => {
        if (snapshot.val()) {
          const data = snapshot.val();

          if (!data) return;

          const regionKeys = Object.keys(area.Regions); //coming from area object

          console.log("Region keys:", regionKeys);

          for (let index = 0; index < regionKeys.length; index++) {
            const element = regionKeys[index];
            if (element === regionId) {
              console.log("Matched region key:", element);
              matchedEntry = element;
              break;
            }
          }

          if (matchedEntry) {
            return UpdateAreaRegionRef(areaId).child(matchedEntry).remove();
          } else {
            console.log("Value not found.");
            dispatch({
              type: REMOVE_REGION_FAIL,
              payload: "Error: This area has no regions assigned to it",
            });
          }
        }
      })
    } catch (error) {
      dispatch({
        type: REMOVE_REGION_FAIL,
        payload: "Error: This area has no regions assigned to it",
      });
      console.error("Failed to remove region from area:", error);
    }

    //remove area from region
    try {
      console.log("Removing Area from region:", areaId);

      UpdateRegionRef(matchedEntry).once('value')
        .then(async snapshot => { //snapshot contains the areas in the region
          const data = snapshot.val();
          if (!data) return;
          const entryToDelete = Object.entries(data).find(
            ([key, value]) => value === areaId
          );

          if (entryToDelete) {
            const [matchedKey, matchedValue] = entryToDelete;
            console.log("Matched area key:", matchedKey);
            console.log("Matched area value:", matchedValue);
            UpdateRegionRef(matchedEntry).child(matchedKey).remove();
            try {
              const regionSnapshot = await SingleRegionRef(matchedEntry).once('value');

              console.log(`regionSnapshot: ${JSON.stringify(regionSnapshot)}`)

              dispatch({
                type: UPDATE_REGION_SUCCESS,
                payload: regionSnapshot.val(),
              });
            } catch (error) {
              console.log(`Was unable to provide SingleRegionRef snapshot`)
            }
          } else {
            console.log("Value not found.");
            dispatch({
              type: REMOVE_AREA_FAIL,
              payload: "Error: This region has no areas assigned to it",
            });
          }
        })
        .then(() => {
          console.log("Area entry removed from region.");
        })
        .catch(error => {
          console.error("Error while removing area from region:", error);
          dispatch({
            type: REMOVE_AREA_FAIL,
            payload: "Error: This area has no regions assigned to it",
          });
        });
    } catch (error) {
      console.error("Failed to remove area from region:", error);
      dispatch({
        type: REMOVE_AREA_FAIL,
        payload: "Error: This region has no areas assigned to it",
      });
    }

    dispatch({
      type: REMOVE_AREA_SUCCESS,
      payload: null,
    });

    return { success: true, message: "Area removed!" };

  } catch (error) {
    console.error("Error removing area from region:", error);

    dispatch({
      type: REMOVE_AREA_FAIL,
      payload: error.message,
    });
    return { success: false, message: error.message };
  }
};